import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PostsPage } from "@/features/content/posts";

const search = z.object({
  view: z.enum(["grid", "list"]).optional(),
  status: z.enum(["published", "scheduled", "draft", "failed", "publishing"]).optional(),
  account: z.string().optional(),
  q: z.string().max(100).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/content/posts/")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "Posts · Malfak" }] }),
  component: Posts,
});

function Posts() {
  return <PostsPage search={Route.useSearch()} />;
}
